import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { PosUserResponse } from 'src/app/models/pos-user-response';
import { CommonFunctionService ,UserMerchantData} from './../Common/common-function.service';
import { catchError, map } from 'rxjs';

@Injectable()
export class EmailconfirmationService {
  headers:any;
  token:any;
  constructor( private http:HttpClient,private service: DataService,private common:CommonFunctionService) { }
 
   redirectemailverified(data) {
    return this.http.get(environment.getEmailverified +'?keyVal=' + data);
  }
  checkMobileOTP(data,otpcode) { 
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.checkMobileOTPUrl + '?mobile=' + data+'&code='+otpcode,{ headers:this.headers});
  }
  resendMobileOTP(contactNo,userType){
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.resendMobileOTPUrl+"?contactNo="+ contactNo + '&userType='+userType,{ headers:this.headers})
  }

  resendEmailOTP(emailcode,userType){
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.resendEmailOTPUrl+"?email="+ emailcode + '&userType='+userType,{ headers:this.headers})
  }



  checkEmailOTP(data,otpcode) { 
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.checkEmailOTPUrl + '?email=' + data+'&code='+otpcode,{ headers:this.headers});
  }
  AgentMobileNoConfirmation(data)
  {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" +'IT'+ ":" +"MPORTAL" + ":" + localStorage.getItem('resetToken');
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
      return this.http.post<PosUserResponse>(environment.agentconfirmMobileNoUrl, data,{ headers:this.headers});
     
  }
  AgentEmailIdConfirmation(data)
  {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" +'IT'+ ":" +"MPORTAL" + ":" + localStorage.getItem('resetToken');
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  
      return this.http.post<PosUserResponse>(environment.agentconfirmEmailIdUrl, data,{ headers:this.headers});
    
  }


  GetUserAuthdetails()
  {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" +'IT';
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }








  changePassword(data) {
    return this.service.create(environment.changeTempPassword, data);
  }
  isValidOldPassword(EmailUserName,UserType,data)
  {
    this.GetUserAuthdetails();
  return this.http.get<any>(environment.checkOldPasswordUrl+"?email="+EmailUserName+"&usertype="+UserType+"&passwordhash="+data,{ headers:this.headers});
  }


  createPassword(data, keyval) {
    this.GetUserAuthdetails();
    return this.http.post(
      environment.createPassword + "?keyval=" + keyval,
      data,{ headers:this.headers}
    );
  }


  isValidMerchantKeyId(data,resellerId)
  { 
    this.GetHeaderdetails();
    let merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.isValidMerchantKeyIdUrl + '?merchantKeyId=' + data+"&ResellerId="+resellerId+ "&LoginUserId=" + merchantdata.UserId,{ headers:this.headers})
    .pipe(map(response => response))
    .pipe(catchError(this.common.handleError));
  }
  getresellerdatabasedonurl(url){
    this.GetUserAuthdetails();
    return this.http.get<any>(environment.getresellerdatabasedonurl+"?url="+ url,{ headers:this.headers});
  }
  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }
  SessionToken(data)
  {
    return this.http.post<any>(environment.saveSessionToken, data);
  }

}
